import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	submitButton: {
		id: 'business-form.form-submission.fill-in-view.submit-button',
		defaultMessage: 'Submit',
		description: 'Button label for the submit action',
	},
});
